module.exports = __webpack_public_path__ + "img/abe3fb2.png";